import style from './form-section.module.scss';
import template from '@components/careers/vacancies/vacancies.module.scss';
import { ISpecialitiesItem } from '@components/careers/vacancies/vacancies.interfaces';
import React, { useState } from 'react';
import VacancyForm from '@components/shared/forms/vacancy-form/vacancy-form';
import dynamic from 'next/dynamic';
import { ButtonHandshkaeGreen } from '@components/shared/buttons/button-handshake-green';
const FormSubmitStatus = dynamic(() => import('@components/shared/forms/form-submit-status/form-submit-status'));

const APPLICATION_SUCCESS = {
  text: 'Your CV has been received — thank you! We’ll reach out if your profile matches one of our current or future opportunities.',
};
enum FORM_STATUS {
  active = 'active',
  success = 'success',
  error = 'error',
}
interface IFormSection {
  title: string;
  subtitle: string;
  specialities: ISpecialitiesItem[];
  specialitiesTotal: number;
}

const FormSection = ({ title, subtitle, specialities, specialitiesTotal }: IFormSection) => {
  let [isFormOpen, setFormOpen] = useState(false);
  const [currentFormStatus, setFormStatus] = useState(FORM_STATUS.active);

  const onSubmit = (success: boolean) => {
    setFormOpen(true);
    if (success) {
      setFormStatus(FORM_STATUS.success);
    } else {
      setFormStatus(FORM_STATUS.error);
    }
  };
  return (
    <section className={`${template.section} ${template.section_gray}`}>
      <div className={`${template.container} ${template.container_small} ${template.mb32} ${style.container}`}>
        <div className={`${template.title} ${template.title_large} ${template.text_align_l} ${template.mb16}`}>
          {title}
        </div>
        <div
          className={`${template.text} ${template.text_color_main} ${template.text_small} ${template.text_align_l} ${style.subtitle}`}
          dangerouslySetInnerHTML={{
            __html: subtitle,
          }}
        ></div>
      </div>
      <div className={`${template.container} ${template.container_small} ${style.container}`}>
        {!isFormOpen && <ButtonHandshkaeGreen text="Apply" className="full-width" action={() => setFormOpen(true)} />}
        <VacancyForm
          specialitiesTotal={specialitiesTotal}
          specialities={specialities}
          isOpen={isFormOpen}
          currentFormStatus={currentFormStatus}
          onSubmit={(status: boolean) => onSubmit(status)}
        />
        {currentFormStatus !== FORM_STATUS.active && (
          <div className={style.status__wrapper}>
            <FormSubmitStatus
              status={currentFormStatus === FORM_STATUS.success ? 'success' : 'failure'}
              customSuccess={APPLICATION_SUCCESS}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default FormSection;
